import React from 'react';
import ErrorPage from '@app/src/common/components/error-page/ErrorPage';

const ServerErrorPage = () => (
  <ErrorPage
    error="notification.internal.server.error"
    message="request.to.server.error"
  />
);

export default ServerErrorPage;
